// this is the canonical place that we define all variants of a SpreadBundle.
//
// key is variant name; value is options object. the options should *not*
// change based on the site.
//
// options are as follows:
//
// - `maxContentItems` describes how many items the variant is capable of
//   displaying. any excess items are truncated.
// - `bundleStyles` refers to the css for that specific variant.
//
import column from './styles/column';
import everyday from './styles/everyday';
import everydayGrid from './styles/everydayGrid';
import flexibleGrid from './styles/flexibleGrid';
import grid from './styles/grid';
import listWide from './styles/listWide';
import minidisc from './styles/minidisc';
import navTextLink from './styles/navTextLink';
import nestedGrid from './styles/nestedGrid';
import simpleList from './styles/simpleList';
import thumbnailList from './styles/thumbnailList';
import soundbar from './styles/soundbar';
import spotlight from './styles/spotlight';
import surroundSound from './styles/surroundSound';
import textLink from './styles/textLink';
import threeGrid from './styles/threeGrid';
import widescreenGrid from './styles/widescreenGrid';

const VARIANTS = {
  column: {
    maxContentItems: 12,
    bundleStyles: column
  },
  expandedGrid: {
    maxContentItems: 12,
    bundleStyles: grid
  },
  everyday: {
    maxContentItems: 1,
    bundleStyles: everyday
  },
  everydayGrid: {
    maxContentItems: 4,
    bundleStyles: everydayGrid
  },
  flexibleGrid: {
    maxContentItems: 16,
    bundleStyles: flexibleGrid
  },
  flood: {
    maxContentItems: 12,
    bundleStyles: threeGrid
  },
  grid: {
    maxContentItems: 12,
    bundleStyles: grid
  },
  listWide: {
    maxContentItems: 24,
    bundleStyles: listWide
  },
  minidisc: {
    maxContentItems: 5,
    bundleStyles: minidisc
  },
  navTextLink: {
    maxContentItems: 3,
    bundleStyles: navTextLink
  },
  nestedGrid: {
    maxContentItems: 12,
    bundleStyles: nestedGrid
  },
  porthole: {
    maxContentItems: 3,
    bundleStyles: threeGrid
  },
  simpleList: {
    maxContentItems: 24,
    bundleStyles: simpleList
  },
  thumbnailList: {
    maxContentItems: 24,
    bundleStyles: thumbnailList
  },
  soundbar: {
    maxContentItems: 1,
    bundleStyles: soundbar
  },
  spotlight: {
    maxContentItems: 3,
    bundleStyles: spotlight
  },
  stream: {
    maxContentItems: 12,
    bundleStyles: listWide
  },
  surroundSound: {
    maxContentItems: 12,
    bundleStyles: surroundSound
  },
  textLink: {
    maxContentItems: 12,
    bundleStyles: textLink
  },
  threeExpandedGrid: {
    maxContentItems: 12,
    bundleStyles: threeGrid
  },
  threeGrid: {
    maxContentItems: 12,
    bundleStyles: threeGrid
  },
  widescreenGrid: {
    maxContentItems: 12,
    bundleStyles: widescreenGrid
  }
};

export default VARIANTS;

export const DEFAULT_VARIANT = 'stream';
